import { render, staticRenderFns } from "./ContestPersonal.vue?vue&type=template&id=0f068988&scoped=true&"
import script from "./ContestPersonal.vue?vue&type=script&lang=js&"
export * from "./ContestPersonal.vue?vue&type=script&lang=js&"
import style0 from "./ContestPersonal.vue?vue&type=style&index=0&id=0f068988&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f068988",
  null
  
)

export default component.exports